import { render, staticRenderFns } from "./brandForm.vue?vue&type=template&id=3f9285b6&scoped=true&"
import script from "./brandForm.vue?vue&type=script&lang=js&"
export * from "./brandForm.vue?vue&type=script&lang=js&"
import style0 from "./brandForm.vue?vue&type=style&index=0&id=3f9285b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9285b6",
  null
  
)

export default component.exports